export function formatPrice(number) {
  if (typeof number !== "number" && !number) return null;

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(number);
}
